class ImageNotAllowedException extends Error {
}
export default ImageNotAllowedException;
